import React from 'react'
import SettingBoxesPage from './SettingBoxesPage'
import '../styles/_index.scss'

function SettingBoxesContainer() {
    return (
        <div className='SettingBoxesContainer'>
            <SettingBoxesPage />
        </div>
    )
}

export default SettingBoxesContainer